var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-vcentered"},[_c('div',{staticClass:"column is-1 is-cursor-pointer",on:{"click":function($event){return _vm.selectAll()}}},[_c('b-icon',{staticClass:"mgt-5px",attrs:{"icon":_vm.iconSelectTotal}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }